/**
 * 配合 IOS 使用时的初始化方法
 */
const iosFunction = (callback) => {
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  const WVJBIframe = document.createElement("iframe");
  WVJBIframe.style.display = "none";
  WVJBIframe.src = "https://__bridge_loaded__";
  document.documentElement.appendChild(WVJBIframe);
  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
};
/**
 * 配合 Android 使用时的初始化方法
 */
const androidFunction = (callback) => {
  if (window.WebViewJavascriptBridge) {
    callback(window.WebViewJavascriptBridge);
  } else {
    document.addEventListener(
      "WebViewJavascriptBridgeReady",
      function () {
        callback(window.WebViewJavascriptBridge);
      },
      false
    );
  }
};

const init = () => {
  // 这里根据移动端原生的 userAgent 来判断当前是 Android 还是 ios
  const u = navigator.userAgent;
  // Android终端
  const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
  // IOS 终端
  // const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  window.setupWebViewJavascriptBridge = isAndroid
    ? androidFunction
    : iosFunction;
  // if (isAndroid) {
  //     /**
  //      * 与安卓交互时，不调用这个函数会导致：
  //      *      1、H5 可以正常调用 安卓这边的事件函数，但是无法再调用到 H5 的回调函数
  //      *
  //      * 前提 setupWebViewJavascriptBridge 这个函数使用的是 andoirFunction 这个，否则还是会导致上面 1 的现象出现
  //      */
  //     window.setupWebViewJavascriptBridge(function (bridge: any) {
  //         // 注册 H5 界面的默认接收函数（与安卓交互时，不注册这个事件无法接收回调函数）
  //         bridge.init(function (msg: any, responseCallback: () => void) {
  //             responseCallback();
  //         });
  //         // 注册方法 客户端调用
  //         //   bridge.registerHandler("hybridInit", function(data, responseCallback) {
  //         //      // responseCallback(responseData);
  //         //  });
  //     });
  // }
};

export default init;
